import { Link } from 'react-router';
import { dsClass } from '../../common/constants/dsClasses.js';
import { paths } from '../../common/constants/pathVariables.js';
import { t } from '../../common/i18n/index.js';

const shareYourNetworkAcrossMultipleDevicesWithRouterMsg = 'Share your network across multiple devices with a router';

export const RoutersPromotionBlock = () => {
  return (
    <section aria-label={t.SDU1(shareYourNetworkAcrossMultipleDevicesWithRouterMsg)}>
      <div>
        <h2 className={dsClass.H3}>{t.SDU1(shareYourNetworkAcrossMultipleDevicesWithRouterMsg)}</h2>
        <p>
          {t.SDU2(
            'Get the most out of your mobile broadband with a router. With a router, you can share the network with a wireless WiFi network to various devices, such as computers, tablets and a TV. Choose a 4G router for a 4G subscription and a 5G router for a 5G subscription.'
          )}
        </p>
        <Link
          className={`${dsClass.LINK} ${dsClass.LINK_STYLE_LINK_BUTTON} ${dsClass.LINK_BUTTON_COLOR_LIGHT} ${dsClass.LINK_BUTTON_SIZE_L} ${dsClass.MARGIN_TOP_6}`}
          to={paths.ROUTERS}
        >
          {t.SDU3('See all routers')}
        </Link>
      </div>
    </section>
  );
};
